import type { identidade as pt } from '../pt-BR/identidade';
import type { Traducao } from '../Traducao';

export const identidade = {
  titulo: 'Your record',
  vinculado: 'Record found: {{nome}}',
  falha: {
    titulo: 'We could not find your record',
    descricao:
      'We could not match your login to a professional record. Contact the team responsible for the campaign.',
  },
  ultimoConhecido: 'Showing the last check; the record is temporarily unavailable.',
} as const satisfies Traducao<typeof pt>;
